/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Appointment } from '../models/appointment';
import { AppointmentCalendar } from '../models/appointment-calendar';
import { createAppointment } from '../fn/appointment/create-appointment';
import { CreateAppointment$Params } from '../fn/appointment/create-appointment';
import { deleteAppointment } from '../fn/appointment/delete-appointment';
import { DeleteAppointment$Params } from '../fn/appointment/delete-appointment';
import { findAppointments } from '../fn/appointment/find-appointments';
import { FindAppointments$Params } from '../fn/appointment/find-appointments';
import { findOnlineAppointments } from '../fn/appointment/find-online-appointments';
import { FindOnlineAppointments$Params } from '../fn/appointment/find-online-appointments';
import { getAppointmentById } from '../fn/appointment/get-appointment-by-id';
import { GetAppointmentById$Params } from '../fn/appointment/get-appointment-by-id';
import { modifyAppointment } from '../fn/appointment/modify-appointment';
import { ModifyAppointment$Params } from '../fn/appointment/modify-appointment';
import { ReportDto } from '../models/report-dto';

@Injectable({ providedIn: 'root' })
export class AppointmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAppointmentById()` */
  static readonly GetAppointmentByIdPath = '/api/appointments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAppointmentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppointmentById$Response(params: GetAppointmentById$Params, context?: HttpContext): Observable<StrictHttpResponse<Appointment>> {
    return getAppointmentById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAppointmentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppointmentById(params: GetAppointmentById$Params, context?: HttpContext): Observable<Appointment> {
    return this.getAppointmentById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Appointment>): Appointment => r.body)
    );
  }

  /** Path part for operation `modifyAppointment()` */
  static readonly ModifyAppointmentPath = '/api/appointments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyAppointment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyAppointment$Response(params: ModifyAppointment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyAppointment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyAppointment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyAppointment(params: ModifyAppointment$Params, context?: HttpContext): Observable<void> {
    return this.modifyAppointment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAppointment()` */
  static readonly CreateAppointmentPath = '/api/appointments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAppointment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAppointment$Response(params: CreateAppointment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAppointment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAppointment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAppointment(params: CreateAppointment$Params, context?: HttpContext): Observable<void> {
    return this.createAppointment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAppointment()` */
  static readonly DeleteAppointmentPath = '/api/appointments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAppointment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointment$Response(params: DeleteAppointment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAppointment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAppointment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointment(params: DeleteAppointment$Params, context?: HttpContext): Observable<void> {
    return this.deleteAppointment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `findAppointments()` */
  static readonly FindAppointmentsPath = '/api/appointments';

  /**
   * Returns appointments for a maximum range of 31 days for given book and optional resources
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAppointments()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppointments$Response(params: FindAppointments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppointmentCalendar>>> {
    return findAppointments(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns appointments for a maximum range of 31 days for given book and optional resources
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAppointments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppointments(params: FindAppointments$Params, context?: HttpContext): Observable<Array<AppointmentCalendar>> {
    return this.findAppointments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AppointmentCalendar>>): Array<AppointmentCalendar> => r.body)
    );
  }

  /** Path part for operation `findOnlineAppointments()` */
  static readonly FindOnlineAppointmentsPath = '/api/appointments/report/online';

  /**
   * Returns online appointments by year and month
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOnlineAppointments()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOnlineAppointments$Response(params: FindOnlineAppointments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportDto>>> {
    return findOnlineAppointments(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns online appointments by year and month
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOnlineAppointments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOnlineAppointments(params: FindOnlineAppointments$Params, context?: HttpContext): Observable<Array<ReportDto>> {
    return this.findOnlineAppointments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportDto>>): Array<ReportDto> => r.body)
    );
  }

}
